<script setup>
defineProps({
  tileImage: { type: String, default: '' },
  tileTitle: { type: String, default: '' },
  tileSubtitle: { type: String, default: '' },
  isFocused: { type: Boolean, default: false },
  hasBadge: { type: Boolean, default: false },
  badgeCopy: { type: String, default: '' },
});

// // TvP08ContentTile setup functions

// // TvP08ContentTile handler functions

// // TvP08ContentTile watchers
</script>

<template>
  <div class="tvp-08-content-tile" :class="{ 'tvp-08-content-tile--focused': isFocused }">
    <div class="tvp-08-content-tile__image-wrap">
      <img class="tvp-08-content-tile__image" :src="tileImage" :alt="tileTitle" />
      <span v-if="hasBadge" class="tvp-08-content-tile__badge">{{ badgeCopy }}</span>
    </div>
    <div class="tvp-08-content-tile__title">{{ tileTitle }}</div>
    <div v-if="tileSubtitle" class="tvp-08-content-tile__subtitle">{{ tileSubtitle }}</div>
  </div>
</template>

<style scoped lang="scss">
@use './tvp08contenttile.scss';
</style>
